import { BaseViewModel } from "../Base/BaseViewModel";
import { IManageEntities } from "./ItemsManager";



export class EntityManagerRegistrar {

    public static RegisterManager<T extends BaseViewModel>(typeName: string, mgr: IManageEntities<T>) {
        if (this._mgrs.has(typeName)) {
            console.warn(`Tried to register more than one manager for a single typename (${typeName}).`);
            return;
        }
        this._mgrs.set(typeName, mgr);
    }

    public static GetManager<T extends BaseViewModel>(typeName: string): IManageEntities<T> | undefined {
        var mgr = this._mgrs.get(typeName);
        var retVal = mgr as unknown as IManageEntities<T>;
        return retVal;
    }



    private static _mgrs = new Map<string, IManageEntities<any>>();
}